import Amplisky from '@sky-it-livedata/amplisky';

export const singletonClient = {
  client: null,
  init(config) {
    if (this.client) {
      return this.client;
    }
    this.client = new Amplisky(config);
    return this.client;
  },
};
